<template>
    <div id="app" v-cloak>
        <!-- <router-view /> -->
        <div @click="isQuit = true" class="quit" v-show="isShow">
            <img src="@/assets/images/logout_butten.png" alt="" />
        </div>
        <MainPage v-show="showPage == 'main'" @handleGoFinish="handleGoFinish" :lang="langarr" :language="language"></MainPage>
        <FinishPage v-if="showPage == 'finish'" @handleCreated="handleCreated" @handleFinish="handleFinish"></FinishPage>
        <AwardPage v-if="showPage == 'award'"></AwardPage>
        <div class="loggedWrap" v-show="isQuit">
            <div class="logged" v-for="(item, index) in langarr" :key="index">
                <div class="text">{{ item[30] }}</div>
                <div class="close" @click="handleQuit">{{ item[31] }}</div>
                <p></p>
                <div class="close request" @click="isQuit = false">
                    <h5>{{ item[32] }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { myHTTP } from './utils/net'
import { lang } from '@/tool/archeroLang'
import FinishPage from '@/pages/finish'
import AwardPage from '@/pages/award'
import MainPage from '@/pages/main'
import uaParser from 'ua-parser-js'

const ua = uaParser(navigator.userAgent)
import queryString from 'query-string'

let parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        FinishPage,
        AwardPage,
        MainPage
    },
    data() {
        return {
            isShow: false,
            showPage: 'main',
            isQuit: false,
            giftCode: '',
            status: false,
            language: '',
            lang2: '',
            langarr: [{}]
        }
    },
    mounted() {
        if (parsed.clear) {
            localStorage.clear()
            let path = this.$route.path
            window.location = path
            this.showPage = 'main'
        }
        for (let i in lang) {
            this.langarr[0][i] = lang[i][this.language]
        }
        if (parsed.d || localStorage.getItem('d')) {
            this.isShow = true
        }
    },
    created() {
        let type = ua.device.type
        if (type == 'mobile') {
            this.init()
            this.getLanguage()
        } else {
            alert('Currently not supported on PC')
            this.showPage = ''
            return
        }
        this.getLanguage()
    },
    methods: {
        init() {
            ;(function (doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight

                        if (!clientWidth) return
                        if (clientWidth < 1200) {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = 14 * (clientWidth / 1080) + 'px'
                            } else {
                                docEl.style.fontSize = 16 * (clientWidth / 1080) + 'px'
                            }
                            if (clientWidth > 1023) {
                                if (this.language === 'ja') {
                                    docEl.style.fontSize = '16px'
                                } else {
                                    docEl.style.fontSize = '16px'
                                }
                            }
                        } else {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = '16px'
                            } else {
                                docEl.style.fontSize = '18px'
                            }
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
        },
        getLanguage() {
            if (
                parsed.language &&
                (parsed.language === 'en' ||
                    parsed.language === 'zh-TW' ||
                    parsed.language === 'zh-CN' ||
                    parsed.language === 'ja' ||
                    parsed.language === 'ko')
            ) {
                this.language = parsed.language
                // this.abc = this.language
                this.lang2 = this.language.substr(0, 2)
                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            } else {
                var type = navigator.appName
                if (type == 'Netscape') {
                    var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
                } else {
                    var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
                }
                var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
                this.lang2 = lang2
                if (lang2 === 'zh') {
                    let zh = lang.substr(0, 5)
                    this.language = zh
                } else if (lang2 == 'ko') {
                    this.language = 'ko'
                } else if (lang2 == 'ja') {
                    this.language = 'ja'
                } else {
                    this.language = 'en'
                }
                if (this.language === 'zh-cn') {
                    this.language = 'zh-CN'
                }
                if (this.language === 'zh-tw') {
                    this.language = 'zh-TW'
                }
                if (['en', 'ja', 'ko', 'zh-CN', 'zh-TW'].indexOf(this.language) < 0) {
                    this.language = 'en'
                }
                // this.abc = this.language

                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            }
        },
        handleGoFinish() {
            // this.giftCode = data
            // this.status = status
            this.showPage = 'finish'
        },
        handleCreated() {
            this.showPage = 'main'
        },
        handleFinish() {
            this.showPage = 'award'
        },
        handleQuit() {
            localStorage.removeItem('d')
            this.isQuit = false
            let path = this.$route.path
            window.location = path
            this.showPage = 'main'
        }
    }
}
</script>

<style  lang="less">
[v-cloak] {
    display: none;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0 !important;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
#app {
    position: relative;
    margin: 0 auto;
    max-width: 1024px !important;
    overflow: hidden;
    font-family: CookieRunBold;
}
.quit {
    position: absolute;
    // top: 2.25rem;
    top: 0;
    // left: 2.25rem;
    left: 0.85rem;
    z-index: 2;
    transform: translateY(-2rem);
    img {
        // width: 4.25rem;
        width: 9.25rem;
    }
}
.loggedWrap {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.54);
    line-height: 1.2;
    .logged {
        position: absolute;
        width: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -70%);
        background: #ffffff;
        width: 56.25rem;
        box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.78);
        text-align: center;
        border-radius: 1.5rem;
        padding: 1.125rem 1.125rem 6.25rem;
    }
    .btn {
        height: 4rem;
        text-align: right;
        img {
            width: 4rem;
        }
    }
    p {
        height: 3rem;
    }
    .text {
        padding: 7.25rem 7.5rem;
        font-size: 2.25rem;
        span {
            color: #4380ff;
        }
    }
    .close {
        width: 39.5625rem;
        height: 9.4375rem;
        line-height: 9.4375rem;
        color: #ffffff;
        font-size: 3.125rem;
        display: inline-block;
        border-radius: 4.8125rem;
        background: #568dff;
    }
    .request {
        border: 2px solid #568dff;
        color: #568dff;
        background: #ffffff;
    }
}
</style>




// WEBPACK FOOTER //
// src/App.vue